import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/cms/restaurant-suppliers/warehouses';
export const getRelationWarehousesEndpointIdentifier = endpoint;

type TData = { data: { id: number; name: string; isAssigned: boolean }[] };
type TError = AxiosError;
type TQueryKey = [string, { restaurantId: number; supplierId: number }];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetRelationWarehousesApi(restaurantId: number, supplierId: number, options?: Options): ReturnType {
  const toast = useCustomToast();

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint, { params: { restaurantId, supplierId } });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([endpoint, { restaurantId, supplierId }], queryFn, options);
}
